import React, { useEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import { HelperText, TextInput } from 'react-native-paper';
import PropTypes from 'prop-types';

export default function WaterAccess({
  actions,
  appStyles,
  pageContent,
  toggleDisableNextStep,
}) {
  const { handleChange, handleBlur, touched, values, errors } = actions;

  useEffect(() => {
    if (
      (errors.waterAccessMonths && touched.waterAccessMonths) ||
      !touched.waterAccessMonths ||
      (errors.waterAccessHours && touched.waterAccessHours) ||
      !touched.waterAccessHours ||
      (errors.waterAccessFlowRate && touched.waterAccessFlowRate) ||
      !touched.waterAccessFlowRate
    ) {
      toggleDisableNextStep(true);
    } else {
      toggleDisableNextStep(false);
    }
  }, [errors, touched]);

  return (
    <View style={styles.container}>
      <TextInput
        mode={'outlined'}
        label={pageContent[0]}
        keyboardType="number-pad"
        onChangeText={handleChange('waterAccessMonths')}
        onBlur={handleBlur('waterAccessMonths')}
        value={values.waterAccessMonths}
        error={touched.waterAccessMonths && errors.waterAccessMonths}
      />
      {touched.waterAccessMonths && errors.waterAccessMonths ? (
        <HelperText type="error" style={appStyles.helperTextError}>
          {errors.waterAccessMonths}
        </HelperText>
      ) : (
        <HelperText style={appStyles.helperText}>{pageContent[1]}</HelperText>
      )}
      <TextInput
        style={styles.textInput}
        mode={'outlined'}
        label={pageContent[2]}
        keyboardType="number-pad"
        onChangeText={handleChange('waterAccessHours')}
        onBlur={handleBlur('waterAccessHours')}
        value={values.waterAccessHours}
        error={touched.waterAccessHours && errors.waterAccessHours}
      />
      {touched.waterAccessHours && errors.waterAccessHours ? (
        <HelperText type="error" style={appStyles.helperTextError}>
          {errors.waterAccessHours}
        </HelperText>
      ) : (
        <HelperText style={appStyles.helperText}>{pageContent[3]}</HelperText>
      )}
      <TextInput
        style={styles.textInput}
        mode={'outlined'}
        label={pageContent[4]}
        keyboardType="number-pad"
        onChangeText={handleChange('waterAccessFlowRate')}
        onBlur={handleBlur('waterAccessFlowRate')}
        value={values.waterAccessFlowRate}
        error={touched.waterAccessFlowRate && errors.waterAccessFlowRate}
      />
      {touched.waterAccessFlowRate && errors.waterAccessFlowRate ? (
        <HelperText type="error" style={appStyles.helperTextError}>
          {errors.waterAccessFlowRate}
        </HelperText>
      ) : (
        <HelperText style={appStyles.helperText}>{pageContent[5]}</HelperText>
      )}
    </View>
  );
}

WaterAccess.propTypes = {
  actions: PropTypes.shape({
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    values: PropTypes.object,
    errors: PropTypes.object,
  }),
  appStyles: PropTypes.object,
  pageContent: PropTypes.array,
  toggleDisableNextStep: PropTypes.func,
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  textInput: {
    marginTop: 15,
  },
});
